/**
 * Sorted list of GPS provider module names available for selection.
 * Credential fields are no longer held here — they come from the server
 * (create_gps_provider step 1 / update_gps_provider step 1).
 */
export const GPS_PROVIDER_NAMES: string[] = [
  "activegps",
  "alior_leasing",
  "atkgps",
  "atrax",
  "autogps",
  "carnet",
  "cartrack",
  "datasystem",
  "dbk",
  "dbk_shared",
  "digitrack",
  "dkv",
  "eco_truck",
  "ecofleet_share",
  "emtrack_advanced",
  "eurowag",
  "fleethand",
  "flotis",
  "flotman_share",
  "fmsolutions",
  "gbox",
  "gbox_share",
  "geonavi",
  "geonavi_native",
  "geonavi_share",
  "globalgps",
  "gpsour",
  "gpsserver",
  "gpste",
  "holte",
  "holte_share",
  "hosting_wialon",
  "infis",
  "juwentus",
  "k2gps",
  "k2gps_share",
  "keratronik",
  "lemar",
  "leonsystem_share",
  "loctracker",
  "logisat",
  "logisat_share",
  "lontextm_pl",
  "mking",
  "motogps",
  "mytracko",
  "mytracko_share",
  "navifleet",
  "navifleet_share",
  "navigator",
  "naviman",
  "navirec",
  "navitrack_share",
  "pangps",
  "ruptela",
  "ruptela_share",
  "scania",
  "skantransport",
  "strefagps",
  "supervisor",
  "tachobus",
  "tekom",
  "tekom_share",
  "teltonika",
  "teltronicpro",
  "trackgps_share",
  "trackingtool_share",
  "tronik",
  "txtango",
  "verizon",
  "viasat",
  "webeye",
  "webeye_xml",
  "webfleet",
  "websat_share",
  "wialon",
  "widziszwszystko",
  "widziszwszystko_share",
]
